export default __webpack_public_path__ + "static/media/mountain.a762db5f.jpg";